module.exports = __webpack_public_path__ + "static/media/p8.02fccb1f.png";